import { RouteNode } from '@coool/route-node';

export const HelpUrls = new RouteNode(':language', {
  Home: new RouteNode(),

  Articles: new RouteNode('articles/:articleLink', undefined, {
    params: {
      articleLink: 'articleLink',
    },
  }),
}, {
  params: {
    language: 'language',
  },
});